import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	container: {
		width: "100%"
	},
	statusActive: {
		color: colors.green[600]
	},
	statusBanned: {
		color: colors.red[600]
	},
	qualityGreen: {
		color: colors.green[600]
	},
	qualityYellow: {
		color: colors.yellow[600]
	},
	qualityRed: {
		color: colors.red[600]
	},
	qualityUnknown: {
		color: colors.gray[400]
	},
	tableContainer: {
		marginTop: theme.spacing(4)
	},
	tableTitle: {
		marginBottom: theme.spacing(2),
		fontWeight: 600
	},
	adminPayload: {
		backgroundColor: colors.gray[50],
		padding: theme.spacing(1),
		borderRadius: "4px",
		marginTop: theme.spacing(1),
		whiteSpace: "pre-wrap",
		wordBreak: "break-all",
		fontSize: "0.75rem",
		fontFamily: "monospace"
	},
	warningCard: {
		backgroundColor: colors.red[50],
		border: `1px solid ${colors.red[200]}`,
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		borderRadius: "8px"
	},
	dot: {
		height: 8,
		width: 8,
		borderRadius: "50%",
		display: "inline-block",
		marginRight: theme.spacing(1)
	},
	card: {
		padding: "24px",
		boxShadow: "none"
	},
	cardTitle: {
		fontSize: "20px",
		fontWeight: 700
	},
	cardSubtitle: {
		fontSize: "16px",
		marginTop: "8px",
		color: "inherit"
	},
	accountStatusCard: {
		color: colors.purple[400],
		background: colors.purple[50]
	},
	accountBannedStatusCard: {
		color: colors.red[400],
		background: colors.red[50]
	},
	accountStatusIcon: {
		color: colors.purple[400]
	},
	restrictionInfoCard: {
		color: colors.red[400],
		background: colors.red[50]
	},
	accountRestrictionIcon: {
		color: colors.red[400]
	},
	phoneQualityCard: {
		color: colors.blue[600],
		background: colors.blue[50]
	},
	accountQualityIcon: {
		color: colors.blue[600]
	},
	messagingLimitCard: {
		color: colors.green[600],
		background: colors.green[50]
	},
	accountMessagingLimitIcon: {
		color: colors.green[600]
	},
	showMoreButton: {
		fontWeight: 600,
		cursor: "pointer"
	}
}))

export default useStyles
